import Col from "react-bootstrap/Col";
import React from "react";
import PropTypes from "prop-types";

const IntegrationTable = (props) => {
    const { tableRows, handleChangeSave, csvColumnList } = props;

    return (
        <Col style={{ display: "flex", flexDirection: "column" }} className='selectWrapper col-6'>
            {csvColumnList.length > 0 && csvColumnList.map((item, index) => (
                <select
                    key={item.id}
                    className="select"
                    aria-label="Default select example"
                    name="csvintegrationcolumnsmapping"
                    onChange={(e) => handleChangeSave(e, index)}
                    value={item.mapId}
                >
                    {tableRows.map((column) => (
                        <option key={column?.id} value={column.mapId} disabled={column.mapId && csvColumnList.some((listItem) => listItem.mapId === column.mapId)}>
                            {column.name}
                        </option>
                    ))}
                </select>
            ))}
        </Col>
    );
};

IntegrationTable.propTypes = {
    tableRows: PropTypes.array.isRequired,
    handleChangeSave: PropTypes.func.isRequired,
    csvColumnList: PropTypes.array.isRequired,
};

export default IntegrationTable;